import { RxCollectionCreator } from 'rxdb';

export abstract class MigrationStep {
	private next: MigrationStep = null;
	public abstract readonly version: number;
	public constructor(protected loggingService) {}

	public setNextVersion(next: MigrationStep): MigrationStep {
		this.next = next;
		return this;
	}

	public hasNext(): boolean {
		return this.next !== null;
	}

	public getNext(): MigrationStep {
		return this.next;
	}

	protected shouldSkipMigration(version: number): boolean {
		return this.version <= version;
	}

	public abstract applyMigrationOnSchema(collectionToMigrate: RxCollectionCreator): RxCollectionCreator;
}
